import { render, staticRenderFns } from "./BdRight.vue?vue&type=template&id=9493f0ca&scoped=true&"
import script from "./BdRight.vue?vue&type=script&lang=js&"
export * from "./BdRight.vue?vue&type=script&lang=js&"
import style0 from "./BdRight.vue?vue&type=style&index=0&id=9493f0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9493f0ca",
  null
  
)

export default component.exports